import React from 'react';
import styled from 'styled-components';

const LoadingCss = styled.div`
width: 100%;
height: 80vh;
.background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  backdrop-filter: blur(3px);
  animation: backdrop-animation 1s ease-in-out infinite 0s forwards !important;
}
@keyframes backdrop-animation {
        0%  {
              backdrop-filter: blur(0px);     
            }
        50% {
              backdrop-filter: blur(3px);     
            }
        100%{
              backdrop-filter: blur(0px);     
            }
    }

/* HTML: <div class="loader"></div> */
.loader {
  scale: 1.5;
  width: 35px;
  aspect-ratio: 1;
  --_g: no-repeat radial-gradient(circle closest-side,var(--prime-2) 90%,#0000);
  background: 
    var(--_g) 0    0,
    var(--_g) 0    100%,
    var(--_g) 100% 100%;
  background-size: 40% 40%;
  animation:l11 0.5s infinite linear;
}
@keyframes l11 {
    25% {background-position:100% 0   ,0 100%,100% 100%}
    50% {background-position:100% 0   ,0 0   ,100% 100%}
    75% {background-position:100% 0   ,0 0   ,0    100%}
    100%{background-position:100% 100%,0 0   ,0    100%}
}


.body{
  background-color: #f7f7f7;
  z-index: 800;
  width: 80px;
  height: 80px;
  position: fixed;
  top: calc(50% - 65px);
  left: calc(50% - 65px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 5px 10px 0 #888;
  padding: 25px 25px;
  border-radius: 1rem;
}
.body img{
  width: 90%;
  margin: 0 auto;
}



/* loading animation*/
.lds-ellipsis {
  margin:  auto 0;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 20px;
}
.lds-ellipsis div {
  position: absolute;
  top: 3.5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--prime-1);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0) translate(-24px, 0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0) translate(24px, 0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

`;

export const LoadingFull = () => {
    return (
        <LoadingCss>
            {/* <div className="background">
            </div> */}
            {/* <div className="loader">
              <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div> */}
            <div className='body'>
              <div className="loader"></div>
            </div>
        </LoadingCss>
    );
}